import React from "react";
import Cards from "./cards/Cards";
import { DashboardData } from "../../types";
import Targets from "./targets/Targets";
import Customers from "../customers/Customers";
import CustomerAnalytics from "../analytics/CustomerAnalytics";
import VisitAnalytics from "../analytics/VisitAnalytics";
import CustomerTargets from "./targets/customerTargets/CustomerTargets";

interface ContentsProps {
  propData: DashboardData;
  isLoading: boolean;
}

const Contents: React.FC<ContentsProps> = ({ propData, isLoading }) => {
  return (
    <section className="space-y-6">
      <Cards data={propData} isLoading={isLoading} />
      <Targets data={propData} isLoading={isLoading} />
      <CustomerTargets data={propData} isLoading={isLoading} />
      <Customers data={propData} isLoading={isLoading} />
      <section className="grid mx-auto w-full max-w-6xl grid-cols-1 lg:grid-cols-2 gap-4 items-center">
        <CustomerAnalytics data={propData} isLoading={isLoading} />
        <VisitAnalytics data={propData} isLoading={isLoading} />
      </section>
    </section>
  );
};

export default Contents;
